window.addEventListener('DOMContentLoaded', function () {
  console.log('Shah ally start');

  $('.section-header .section-title').attr('role', 'heading').attr('aria-level', '1');
  $(".grid-item .collection-item__title").removeAttr("role").removeAttr("aria-level");
  $('div[style*="Made_in_USA_Banner"]').attr('role', 'img').attr('aria-label', 'Made in USA');
 
  function updateAriaSelected() {
  $('.grid-view-btn').each(function () {
    if ($(this).hasClass('is-active')) {
      $(this).attr('aria-current', 'true');
    } else {
      $(this).attr('aria-current', 'false');
    }
  });
  }
  updateAriaSelected();
  $('.grid-view-btn').on('click', function () {
    $('.grid-view-btn').removeClass('is-active');
    $(this).addClass('is-active');
    updateAriaSelected();
  });

  setTimeout(() => {
    $('.xo-loadmore.imagebox__btn').attr('role', 'button');
    $('.pswp__button.pswp__button--arrow--left').attr('aria-label', 'Previous Slide');
    $('.pswp__button.pswp__button--arrow--right').attr('aria-label', 'Next Slide');

    $('.klaviyo-form input[placeholder]').addClass('custom-placeholder');
    $('.stockist-search-form input[placeholder]').addClass('custom-placeholder');
  }, 2000);

  // const observer = new MutationObserver(() => {
    // const el = document.getElementById('alia-p3r8jvqffbvsncy0');
    // if (el && el.hasAttribute('role')) {
    //   el.setAttribute('aria-label', 'Close');
    // }
    // $('.wFormContainer .errMsg').addClass('form-assembly-errMsg');
  // });

  const targetNode = document.querySelector('.wFormContainer');
  if (targetNode) {
    const observer = new MutationObserver(() => {
      $('.wFormContainer .errMsg').addClass('form-assembly-errMsg');
    });
  
    observer.observe(targetNode, {
      childList: true,
      subtree: true
    });
  }
});